import "./SupplierAndBuyerPortals.module.css";
import Header from "@/reusable_sections/Header";
import SupplierPortalOverview from "./sections/SupplierPortalOverview";
import SupplierPortalFeatures from "./sections/SupplierPortalFeatures";
import BuyerPortalOverview from "./sections/BuyerPortalOverview";
import BuyerPortalFeatures from "./sections/BuyerPortalFeatures";
import RequestAccess from "./sections/RequestAccess";
import Footer from "@/reusable_sections/Footer";
export default function SupplierAndBuyerPortalsPage() {
  return <div>
      <Header />
      <SupplierPortalOverview />
      <SupplierPortalFeatures />
      <BuyerPortalOverview />
      <BuyerPortalFeatures />
      <RequestAccess />
      <Footer />
    </div>;
}